/* ------------------------------------------------
第一部分：载入基本组件
--------------------------------------------------*/
// 引入基本组件
const {
    //remResizer,// rem字体整体缩放
    //ScrollTracker,   //滚动跟踪器-获取滚动相关参数
    TabSwitcher,  //Tab选项卡
    //CollapsePanel, //折叠面板
    SmoothScrollManager, //平滑滚动
    MainMenuManager, //顶部菜单
    //AnimateNumber, //数字动态增长特效
    DialogManager, //弹出对话框
    //Marquee, //横向滚动
    ScrollMenu, //可横向滚动目录
    FixedScreen, //div固定到屏幕指定位置
    FloatBar, //右侧悬浮工具栏
} = require("xrcms_builder");
/* ------------------------------------------------
第二部分：载入常用第三方库1
--------------------------------------------------*/
// 将jquery作为全局变量，以使其可以在html文件中直接使用
window.$ = window.jQuery = require('jquery');
// 引入Swiper
import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// 引入aos动画库
//import AOS from 'aos';
//import 'aos/dist/aos.css';
/* ------------------------------------------------
第三部分：引入less文件-用于使用自带的webpack.demo.js打包时使用
* less文件会被打包到对应模板的css目录下
* 如果你希望使用如Vscode的第三方插件easy-less的编译功能，请将引入文件注销
--------------------------------------------------*/
import './_less/theme.less';
/* ------------------------------------------------
第四部分：项目代码部分
--------------------------------------------------*/
// 字体大小自适应
//new remResizer();
$(function () {
    // swiper范例
    const swiper = new Swiper('.home-swiper', {
        // Optional parameters
        //direction: 'vertical',
        loop: true,
        autoplay: {
            delay: 3000,
        },

        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        // And if we need scrollbar
        scrollbar: {
            el: '.swiper-scrollbar',
        },
    });
    // 初始化Tab切换器
    new TabSwitcher();
    // 初始化折叠面板
    //new CollapsePanel('.collapse-loop');
    // // 初始化滚动跟踪器
    // const scrollTrackerInstance = new ScrollTracker({
    //     wait: 500,
    // });
    // // 初始化滚动跟踪器
    // $(window).on('scroll', function () {
    //     console.log(scrollTrackerInstance.scrollStorage);
    // });
    // // 初始化平滑滚动
    new SmoothScrollManager();
    // // 初始化顶部菜单
    new MainMenuManager();
    // // 初始化数字动态增长特效
    //const animate = new AnimateNumber();

    // // 重置包含 .xx 类的元素的动画状态
    // $(".resetanimation").on("click", function () {
    //     animate.resetAnimation(".xx");
    // });
    // $(".startanimation").on("click", function () {
    //     animate.activateAnimation(".xx");
    // });
    // 初始化弹出对话框
    new DialogManager();

    // 初始化跑马灯
    //new Marquee('.marquee');
    new ScrollMenu();
    new FixedScreen();
    new FloatBar();

    // 语言菜单切换
    // $(".lang-now").on("click", function () {
    //     $(this).siblings(".lang-menu").slideToggle();
    // });

    // 或带配置项
    // AOS.init({
    //     duration: 800,      // 动画时长（毫秒）
    //     easing: 'ease-in-out', // 缓动函数
    //     once: false,        // 是否只触发一次
    // });
});